import {
  CheckCircleIcon,
  CircleDashed,
  CircleDotDashed,
  CircleDotIcon,
  XCircleIcon,
} from "lucide-react";

import { Tables } from "@kit/supabase/database";
import { Badge } from "@kit/ui/badge";
import { cn } from "@kit/ui/utils";
import { Trans } from "@kit/ui/trans";

export function IssueStatusBadge(props: {
  status: Tables<"issues">["status"];
  className?: string;
}) {
  const status = props.status;

  let Icon: React.ReactElement | null;
  let text = "";

  switch (status) {
    case "planned":
      text = "roadmap:planned";
      Icon = <CircleDashed className={"mr-1 h-3 w-3 text-yellow-600"} />;
      break;
    case "in_progress":
      text = "roadmap:inProgress";
      Icon = <CircleDotDashed className={"mr-1 h-3 w-3 text-green-600"} />;
      break;
    case "completed":
      text = "roadmap:completed";
      Icon = <CheckCircleIcon className={"mr-1 h-3 w-3 text-green-500"} />;
      break;
    case "closed":
      text = "roadmap:closed";
      Icon = <XCircleIcon className={"text-destructive mr-1 h-3 w-3"} />;
      break;
    default:
      Icon = <CircleDotIcon className={"mr-1 h-3 w-3 text-orange-400"} />;
      text = "roadmap:underReview";
      break;
  }

  return (
    <Badge
      className={cn("flex gap-1 px-1.5", props.className)}
      variant={"outline"}
    >
      {Icon}
      <span>
        <Trans i18nKey={text} defaults={text} />
      </span>
    </Badge>
  );
}
